// Header search stays in step with AJAX stock changes on collection/search pages.
document.addEventListener('submit', (event) => {
  const form = event.target;
  if (!(form instanceof HTMLFormElement) || form.getAttribute('role') !== 'search') return;
  const stockInput = form.querySelector('input[name="filter.v.availability"]');
  if (!stockInput) return;
  const current = new URL(window.location.href);
  stockInput.value = current.searchParams.getAll('filter.v.availability').join(',') || stockInput.value || '1';
});
